import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=29b01072&scoped=true&"
var script = {}
import style0 from "./clients.vue?vue&type=style&index=0&id=29b01072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b01072",
  null
  
)

export default component.exports